import React from 'react';
import { Countdown } from './Countdown';
import { PricingCard } from './PricingCard';
import { comparisonRows } from '../data/content';
const tagLine = ['Sessions.', 'Drills.', 'Progressions.', 'Management.', 'All organised.'];
export function Comparison() {
  return <section className="bg-navy-900 px-5 py-16 sm:py-20" data-id="element-49" data-mp="1l5kxdxon77ef">
      <div className="mx-auto max-w-5xl" data-id="element-50" data-mp="1pyw13py5r824">
        <div className="text-center" data-id="element-51" data-mp="1ux7eubrkq2pm">
          <h2 className="mx-auto max-w-3xl font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-52" data-mp="1uw5qj5ljrjpy">
            Your next training session can keep being improvised.{' '}
            <span className="text-gold" data-id="element-53" data-mp="23xnf7cd0stq9">
              Or you can finally have a real system.
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base text-white/60" data-id="element-54" data-mp="28voudm7bs8wg">
            Join hundreds of coaches worldwide who already plan their entire
            season in under 5 minutes.
          </p>
          <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-55" data-mp="ejh7mw55qybr">
            {tagLine.map(tag => <li key={tag} className="rounded-md border border-gold/30 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-56" data-mp="1m20f48mkwj52">
                {tag}
              </li>)}
          </ul>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-white/10" data-id="element-57" data-mp="18adho5gwh4kp">
          <div className="grid grid-cols-2" data-id="element-58" data-mp="24zuvx8ty7yy0">
            <div className="bg-navy-700 px-5 py-4 text-center text-[11px] font-black uppercase tracking-[0.14em] text-white/60 sm:text-xs" data-id="element-59" data-mp="24ys48yosxsh1">
              Without Cricket Ready
            </div>
            <div className="bg-gold px-5 py-4 text-center text-[11px] font-black uppercase tracking-[0.14em] text-navy-900 sm:text-xs" data-id="element-60" data-mp="1vx25f7slbr98">
              With Cricket Ready™
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={row.topic} className={`grid grid-cols-2 ${i % 2 === 0 ? 'bg-navy-800' : 'bg-navy-700'}`} data-id="element-61" data-mp="fk3tf1vv0il4" data-mpi={i}>
              <div className="flex items-start gap-2 border-r border-white/10 px-4 py-4 text-[13px] leading-relaxed text-white/60 sm:px-5" data-id="element-62" data-mp="h2lsgl9a34tm">
                <span aria-hidden="true" data-id="element-63" data-mp="81njrpnwa94p">❌</span>
                <span data-id="element-64" data-mp="80uktav6gnx4">
                  <span className="block font-semibold text-white/80" data-id="element-65" data-mp="83gpn2qoopbn">
                    {row.topic}
                  </span>
                  {row.without}
                </span>
              </div>
              <div className="flex items-start gap-2 px-4 py-4 text-[13px] leading-relaxed text-white/75 sm:px-5" data-id="element-66" data-mp="3uevx3uat6unr">
                <span aria-hidden="true" data-id="element-67" data-mp="3lgagi4owdppm">✅</span>
                <span data-id="element-68" data-mp="3lhlko5m98zh9">
                  <span className="block font-semibold text-grass" data-id="element-69" data-mp="3le7f6oiaoa5l">
                    {row.topic}
                  </span>
                  {row.with}
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-14 text-center" data-id="element-70" data-mp="3ghh30c9m1ypg">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-71" data-mp="3gg5vq2gyi8tl">
            ⏰ Launch price ends in
          </p>
          <Countdown size="lg" data-id="element-72" data-mp="2rwavs1s7asab" />
        </div>

        <div className="mt-10" data-id="element-73" data-mp="2rxlzy2pk621y">
          <PricingCard data-id="element-74" data-mp="2ryfc5j7adjrh" />
        </div>
      </div>
    </section>;
}